import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import EditMembership from "../../components/MembershipPlan/EditMemberShipPlan";


const EditMembershipPage = () => {
  return (
    <>


        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Membership  </h5><Breadcrumb title="Edit Membership" /></div>


        {/* UsersListLayer */}
        <EditMembership />


    </>
  );
};

export default EditMembershipPage; 